/**
 * This function uses `window.btoa` underneath meaning that it only accept the charset allowed in the
 * underlying function.
 *
 * @param {string} data
 */
export const encode = (data) => {
    return window.btoa(data || '');
};

export const decode = (base64String) => {
    return window.atob(base64String || '');
};

/**
 * @param {string} data data to be encoded
 * @returns {string} base64 string that is safe to be sent over URLs
 * @see encode() - This function uses encode including it's constraints
 */
export const encodeSafeURL = (data) => {
    return encode(data).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

export const decodeSafeURL = (base64String) => {
    let replaced = base64String.replace(/-/g, '+').replace(/_/g, '/');
    while (replaced.length % 4) replaced += '=';
    return decode(replaced);
};
